(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bleen-v2-fragrance-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFinder = (root) => {
      if (!root || root.dataset.finderReady === 'true') return;
      root.dataset.finderReady = 'true';

      const panel = root.querySelector('[data-finder-panel]');
      const form = root.querySelector('[data-finder-form]');
      const status = root.querySelector('[data-finder-status]');
      const results = root.querySelector('[data-finder-results]');
      const resultTitle = root.querySelector('[data-results-title]');
      const resultIntro = root.querySelector('[data-results-intro]');
      const primarySlot = root.querySelector('[data-primary-product]');
      const basket = root.querySelector('[data-finder-basket]');
      const productGrid = root.querySelector('[data-finder-product-grid]');
      const productPool = root.querySelector('[data-product-pool]');
      const bundlePrice = root.querySelector('[data-bundle-price]');
      const bundleAddButton = root.querySelector('[data-bundle-add]');
      const emptyState = root.querySelector('[data-finder-empty]');
      const cards = Array.from(root.querySelectorAll('[data-finder-product]'));
      const steps = Array.from(root.querySelectorAll('[data-finder-step]'))
        .sort((first, second) => Number(first.dataset.finderStep) - Number(second.dataset.finderStep));
      const stepNav = Array.from(root.querySelectorAll('[data-step-nav]'));
      const progress = root.querySelector('[data-finder-progress]');
      const progressBar = root.querySelector('[data-progress-bar]');
      const progressPercentage = root.querySelector('[data-progress-percentage]');
      const stepCount = root.querySelector('[data-step-count]');
      const backButton = root.querySelector('[data-finder-back]');
      const nextButton = root.querySelector('[data-finder-next]');
      const submitButton = root.querySelector('[data-finder-submit]');
      const submitLabel = submitButton?.querySelector('.bleen-finder__submit-label');
      const fieldNames = ['mood', 'intensity', 'area'];
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let currentStep = 1;
      let resultTimer;
      let isLoading = false;
      let activeBundleCards = [];

      if (!panel || !form || !results) return;

      const selectedInput = (name) => form.querySelector(`input[name="${name}"]:checked`);
      const selectedValue = (name) => selectedInput(name)?.value || '';
      const selectedLabel = (name) => selectedInput(name)?.dataset.label || '';

      const setFeedback = (message = '', ready = false) => {
        if (!status) return;
        status.textContent = message;
        status.classList.toggle('is-ready', ready);
        status.classList.remove('is-loading');
      };

      const stopLoading = () => {
        window.clearTimeout(resultTimer);
        isLoading = false;
        form.classList.remove('is-loading');
        form.removeAttribute('aria-busy');
        submitButton?.classList.remove('is-loading');
        submitButton?.removeAttribute('aria-busy');
        submitButton?.removeAttribute('aria-label');
      };

      const syncSummary = () => {
        fieldNames.forEach((name) => {
          const label = selectedLabel(name);
          const valueNode = root.querySelector(`[data-summary-value="${name}"]`);
          const row = root.querySelector(`[data-summary-row="${name}"]`);
          if (valueNode) valueNode.textContent = label || '—';
          row?.classList.toggle('is-complete', Boolean(label));
        });
      };

      const updateProgress = () => {
        const percentage = Math.round((currentStep / (steps.length + 1)) * 100);
        if (progress) progress.setAttribute('aria-valuenow', String(currentStep));
        if (progressBar) progressBar.style.width = `${percentage}%`;
        if (progressPercentage) progressPercentage.textContent = `${percentage}%`;
        if (stepCount) stepCount.textContent = root.dataset.stepTemplate.replace('[current]', String(currentStep));

        stepNav.forEach((button, index) => {
          const stepNumber = index + 1;
          const previousFieldsComplete = fieldNames.slice(0, index).every((name) => Boolean(selectedValue(name)));
          button.disabled = stepNumber > 1 && !previousFieldsComplete;
          button.classList.toggle('is-active', stepNumber === currentStep);
          button.classList.toggle('is-complete', Boolean(selectedValue(fieldNames[index])));
          if (stepNumber === currentStep) {
            button.setAttribute('aria-current', 'step');
          } else {
            button.removeAttribute('aria-current');
          }
        });

        if (backButton) backButton.hidden = currentStep === 1;
        if (nextButton) {
          nextButton.hidden = currentStep === steps.length;
          nextButton.disabled = !selectedValue(fieldNames[currentStep - 1]);
        }
        if (submitButton) {
          submitButton.hidden = currentStep !== steps.length;
          submitButton.disabled = !selectedValue(fieldNames[currentStep - 1]);
        }
      };

      const applyStep = (stepNumber, focusTitle = false) => {
        currentStep = Math.min(steps.length, Math.max(1, stepNumber));
        steps.forEach((step) => {
          const active = Number(step.dataset.finderStep) === currentStep;
          step.hidden = !active;
          step.classList.toggle('is-active', active);
        });
        updateProgress();
        setFeedback('');
        if (focusTitle) {
          window.requestAnimationFrame(() => {
            steps[currentStep - 1]?.querySelector('[data-step-title]')?.focus({ preventScroll: true });
          });
        }
      };

      const showStep = (stepNumber, focusTitle = false) => {
        if (!reducedMotion && document.startViewTransition) {
          document.startViewTransition(() => applyStep(stepNumber, focusTitle));
        } else {
          applyStep(stepNumber, focusTitle);
        }
      };

      const validateStep = (stepNumber) => {
        const fieldName = fieldNames[stepNumber - 1];
        const step = steps[stepNumber - 1];
        const valid = Boolean(selectedValue(fieldName));
        step?.classList.toggle('is-missing', !valid);
        if (!valid) {
          setFeedback(root.dataset.chooseOne);
          step?.querySelector(`input[name="${fieldName}"]`)?.focus({ preventScroll: true });
        }
        return valid;
      };

      const reasonTemplate = (type, label) => {
        const template = type === 'profile'
          ? root.dataset.reasonProfile
          : type === 'area'
            ? root.dataset.reasonArea
            : root.dataset.reasonIntensity;
        return template.replace('[value]', label);
      };

      const scoreProducts = () => {
        const area = selectedValue('area');
        const mood = selectedValue('mood');
        const intensity = selectedValue('intensity');
        const intensityOrder = ['delicate', 'balanced', 'persistent'];

        return cards.map((card) => {
          const profiles = (card.dataset.profiles || '').split(',').filter(Boolean);
          const category = card.dataset.category || '';
          const cardIntensity = card.dataset.intensity || 'balanced';
          let score = 0;

          if (area === 'all') {
            score += 2;
          } else if (category === area) {
            score += 6;
          }
          if (profiles.includes(mood)) score += 5;
          if (cardIntensity === intensity) {
            score += 2;
          } else if (Math.abs(intensityOrder.indexOf(cardIntensity) - intensityOrder.indexOf(intensity)) === 1) {
            score += 0.75;
          }

          let reason = '';
          if (area !== 'all' && category === area) {
            reason = reasonTemplate('area', selectedLabel('area').toLowerCase());
          } else if (profiles.includes(mood)) {
            reason = reasonTemplate('profile', selectedLabel('mood').toLowerCase());
          } else {
            reason = reasonTemplate('intensity', selectedLabel('intensity').toLowerCase());
          }

          return {
            card,
            reason,
            score,
            order: Number(card.dataset.order || 0)
          };
        }).sort((a, b) => b.score - a.score || a.order - b.order);
      };

      const selectCompanions = (ranked, primary, limit) => {
        if (!primary) return [];
        const roleOrder = {
          softener: ['detergent', 'floor', 'surface'],
          detergent: ['softener', 'floor', 'surface'],
          floor: ['detergent', 'softener', 'surface'],
          surface: ['detergent', 'softener', 'floor']
        };
        const desiredRoles = roleOrder[primary.card.dataset.basketRole] || ['detergent', 'softener', 'floor'];
        const companions = [];

        desiredRoles.forEach((role) => {
          if (companions.length >= limit) return;
          const match = ranked.find((item) => item !== primary && item.card.dataset.basketRole === role && !companions.includes(item));
          if (match) companions.push(match);
        });

        ranked.forEach((item) => {
          if (companions.length >= limit) return;
          if (item !== primary && !companions.includes(item)) companions.push(item);
        });

        return companions;
      };

      const formatMoney = (cents) => {
        try {
          return new Intl.NumberFormat(root.dataset.locale || 'it-IT', {
            style: 'currency',
            currency: root.dataset.currency || 'EUR'
          }).format(cents / 100);
        } catch (error) {
          return `${(cents / 100).toFixed(2)} €`;
        }
      };

      const updatePrimaryTraits = (card) => {
        fieldNames.forEach((name) => {
          const node = card?.querySelector(`[data-primary-trait="${name}"]`);
          if (node) node.textContent = selectedLabel(name);
        });
        const bars = card?.querySelector('[data-primary-intensity-bars]');
        const level = ['delicate', 'balanced', 'persistent'].indexOf(selectedValue('intensity')) + 1;
        if (bars) bars.dataset.level = String(Math.max(1, level));
      };

      const updateBundle = (cardsToAdd) => {
        activeBundleCards = cardsToAdd;
        const total = cardsToAdd.reduce((sum, card) => sum + Number(card.dataset.price || 0), 0);
        if (bundlePrice) {
          bundlePrice.textContent = root.dataset.bundlePriceTemplate.replace('[price]', formatMoney(total));
        }
        if (bundleAddButton) {
          bundleAddButton.disabled = cardsToAdd.length === 0;
          bundleAddButton.removeAttribute('aria-busy');
          bundleAddButton.textContent = root.dataset.bundleAddTemplate.replace('[count]', String(cardsToAdd.length));
        }
      };

      const renderResults = () => {
        stopLoading();
        const ranked = scoreProducts();
        const companionLimit = Math.max(2, Math.min(4, Number(root.dataset.maxResults || 3)));
        const selectedMood = selectedInput('mood');
        const primary = ranked[0];
        const companions = selectCompanions(ranked, primary, companionLimit);

        cards.forEach((card) => {
          card.hidden = true;
          card.classList.remove('is-primary');
          card.style.removeProperty('--reveal-index');
          productPool?.append(card);
        });

        if (selectedMood) {
          if (resultTitle) resultTitle.textContent = selectedMood.dataset.resultTitle;
          if (resultIntro) resultIntro.textContent = selectedMood.dataset.resultIntro;
        }

        if (primary) {
          const item = primary;
          const compatibility = Math.round(Math.min(98, Math.max(72, 70 + item.score * 2.25)));
          const scoreNode = item.card.querySelector('[data-match-score]');
          const reasonNode = item.card.querySelector('[data-match-reason]');
          if (scoreNode) scoreNode.textContent = root.dataset.matchTemplate.replace('[score]', String(compatibility));
          if (reasonNode) reasonNode.textContent = selectedMood?.dataset.resultIntro || item.reason;
          item.card.style.setProperty('--reveal-index', 0);
          item.card.classList.add('is-primary');
          item.card.hidden = false;
          updatePrimaryTraits(item.card);
          primarySlot?.append(item.card);
        }

        companions.forEach((item, index) => {
          const reasonNode = item.card.querySelector('[data-match-reason]');
          const categoryLabel = (item.card.dataset.categoryLabel || '').toLowerCase();
          if (reasonNode) reasonNode.textContent = root.dataset.basketReasonTemplate.replace('[value]', categoryLabel);
          item.card.style.setProperty('--reveal-index', index + 1);
          item.card.hidden = false;
          productGrid?.append(item.card);
        });

        if (basket) basket.hidden = companions.length === 0;
        updateBundle(primary ? [primary.card, ...companions.map((item) => item.card)] : []);
        if (emptyState) emptyState.hidden = Boolean(primary);
        panel.hidden = true;
        results.hidden = false;
        results.classList.remove('is-visible');
        window.requestAnimationFrame(() => results.classList.add('is-visible'));
        window.setTimeout(() => {
          results.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
          resultTitle?.focus({ preventScroll: true });
        }, reducedMotion ? 0 : 120);
      };

      form.addEventListener('change', (event) => {
        const input = event.target.closest('input[type="radio"]');
        if (!input) return;
        input.closest('[data-finder-step]')?.classList.remove('is-missing');
        syncSummary();
        updateProgress();
        setFeedback(root.dataset.choiceSaved, true);

      });

      nextButton?.addEventListener('click', () => {
        if (!validateStep(currentStep)) return;
        showStep(currentStep + 1, true);
      });

      backButton?.addEventListener('click', () => showStep(currentStep - 1, true));

      stepNav.forEach((button) => {
        button.addEventListener('click', () => {
          if (!button.disabled) showStep(Number(button.dataset.stepNav), true);
        });
      });

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (isLoading) return;
        const firstMissing = fieldNames.findIndex((name) => !selectedValue(name));
        if (firstMissing >= 0) {
          showStep(firstMissing + 1, true);
          validateStep(firstMissing + 1);
          return;
        }

        isLoading = true;
        form.classList.add('is-loading');
        form.setAttribute('aria-busy', 'true');
        submitButton?.classList.add('is-loading');
        submitButton?.setAttribute('aria-busy', 'true');
        submitButton?.setAttribute('aria-label', `${submitLabel?.textContent.trim() || ''}…`);
        if (submitButton) submitButton.disabled = true;
        setFeedback(`${submitLabel?.textContent.trim() || ''}…`);
        status?.classList.add('is-loading');

        resultTimer = window.setTimeout(renderResults, 850);
      });

      bundleAddButton?.addEventListener('click', async () => {
        const items = activeBundleCards
          .map((card) => ({ id: card.dataset.variantId, quantity: 1 }))
          .filter((item) => item.id);
        if (items.length === 0 || bundleAddButton.getAttribute('aria-busy') === 'true') return;

        const defaultLabel = root.dataset.bundleAddTemplate.replace('[count]', String(items.length));
        bundleAddButton.setAttribute('aria-busy', 'true');
        bundleAddButton.disabled = true;
        bundleAddButton.textContent = root.dataset.bundleAdding;

        try {
          const shopRoot = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${shopRoot}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('cart');
          window.location.assign(root.dataset.cartUrl || `${shopRoot}cart`);
        } catch (error) {
          bundleAddButton.textContent = root.dataset.bundleError;
          window.setTimeout(() => {
            bundleAddButton.textContent = defaultLabel;
            bundleAddButton.disabled = false;
            bundleAddButton.removeAttribute('aria-busy');
          }, 2200);
        }
      });

      root.querySelector('[data-finder-edit]')?.addEventListener('click', () => {
        stopLoading();
        results.hidden = true;
        results.classList.remove('is-visible');
        panel.hidden = false;
        showStep(1);
        window.setTimeout(() => panel.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' }), reducedMotion ? 0 : 80);
      });

      root.querySelector('[data-finder-restart]')?.addEventListener('click', () => {
        stopLoading();
        form.reset();
        syncSummary();
        results.hidden = true;
        results.classList.remove('is-visible');
        panel.hidden = false;
        showStep(1, true);
        window.setTimeout(() => panel.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' }), reducedMotion ? 0 : 80);
      });

      syncSummary();
      applyStep(1);
    };

    const initAllFinders = (scope = document) => {
      scope.querySelectorAll('[data-fragrance-finder]').forEach(initFinder);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllFinders());
    } else {
      initAllFinders();
    }

    document.addEventListener('shopify:section:load', (event) => initAllFinders(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
